import { render } from "./EmailBox.vue?vue&type=template&id=721b2e8c&scoped=true"
import script from "./EmailBox.vue?vue&type=script&lang=js"
export * from "./EmailBox.vue?vue&type=script&lang=js"

import "./EmailBox.vue?vue&type=style&index=0&id=721b2e8c&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721b2e8c"]])

export default __exports__